<script lang="ts" setup>
import type { ScaleLinear } from 'd3';
import type { BarChartOptions } from '../index.vue';

const { formatNumberToIsoNumber } = useNumbers();

// Props
defineProps<{
  loading: boolean;
  yScale: ScaleLinear<number, number>;
  options: BarChartOptions;
  numTicks?: number;
  customTicks?: number[];
}>();

// Refs
const yAxisValues = ref<HTMLDivElement[]>([]);

defineExpose({
  yAxisValues,
});
</script>
<template>
  <div
    class="relative h-[calc(100%-var(--marginTop)-var(--marginBottom))] w-[var(--marginLeft)] translate-y-[var(--marginTop)] overflow-visible"
  >
    <!-- Regular tick values -->
    <div
      v-for="(value, i) in customTicks || yScale.ticks(numTicks || 10)"
      ref="yAxisValues"
      :key="i"
      :style="{ top: `${yScale(value)}%` }"
      class="absolute right-0 text-xs tabular-nums -translate-y-1/2 text-gray-400 text-right pr-4 whitespace-nowrap"
    >
      <template v-if="!loading">
        <template v-if="options.y?.unit && i === (customTicks || yScale.ticks(numTicks || 10)).length - 1">
          {{ options.y.unit }}
        </template>
        <template v-else>
          {{ formatNumberToIsoNumber(value, value > 10 ? 0 : 2) }}
        </template>
      </template>
    </div>
  </div>
</template>
